import script from "./creditPublicity.vue?vue&type=script&lang=ts&setup=true"
export * from "./creditPublicity.vue?vue&type=script&lang=ts&setup=true"

import "./creditPublicity.vue?vue&type=style&index=0&id=6e3b5d2a&lang=css"

const __exports__ = script;

export default __exports__